import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { LoadingIcon } from 'components/shared/DesignSystem/Icons';
import { Spinner } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

const Container = styled.div`
  height: 300px;
  background-repeat: round;
  background-image: url('data:image/svg+xml,%3C%3Fxml version="1.0" encoding="UTF-8"%3F%3E%3Csvg width="140px" height="120px" viewBox="0 0 140 120" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"%3E%3C!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EArtboard%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"%3E%3Crect fill="%23FFFFFF" x="0" y="0" width="140" height="120"%3E%3C/rect%3E%3Cg id="Group" transform="translate(20.000000, 22.000000)"%3E%3Cg id="Fill-70-+-Fill-71-+-Fill-72" fill="%23f6f6f6"%3E%3Cpath d="M27.7777778,16.6666667 C33.9,16.6666667 38.8888889,21.6444445 38.8888889,27.7777779 C38.8888889,33.9000001 33.9,38.888889 27.7777778,38.888889 C21.65,38.888889 16.6666667,33.9000001 16.6666667,27.7777779 C16.6666667,21.6444445 21.65,16.6666667 27.7777778,16.6666667 L27.7777778,16.6666667 Z M33.7277778,51.3500001 C34.1888889,50.5777779 35,50.0777779 35.8944444,50.0055557 C36.8055556,49.9555557 37.6666667,50.3111113 38.2444444,51.0000001 L49.3,64.2666669 L61.3611111,37.738889 C61.8166667,36.7222223 62.8388889,36.1111112 63.95,36.1111112 C65.0611111,36.138889 66.0555556,36.8277779 66.4666667,37.8611112 L82.4333333,77.777778 L100,77.777778 L100,0 L0,0 L0,77.777778 L17.8722222,77.777778 L33.7277778,51.3500001 Z" id="Fill-72"%3E%3C/path%3E%3C/g%3E%3Crect id="Rectangle" stroke="%23f6f6f6" stroke-width="7" fill-rule="nonzero" x="-3.5" y="-3.5" width="107" height="83"%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E');
  background-size: 200px;
  background-color: white;
`;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  height: 100%;
  margin: 0 auto;
  background: radial-gradient(ellipse at center, #fff 0, transparent 100%);

  p {
    text-align: center;
    color: var(--cc_color_text_default);
    font-weight: 400;
    font-size: 22px;
    line-height: 1.5;
    margin-bottom: 16px;
  }
`;

const EmptyFeed = ({ message, children, isLoading }) => {
  return (
    <Container>
      <MessageWrapper>
        {!!isLoading && <LoadingIcon />}
        <p>{message}</p>

        {/* TODO: update buttons to react components in design system */}
        {children}
      </MessageWrapper>
    </Container>
  );
};

export const Loading = () => {
  return (
    <Spinner accessibilityLabel={translate('common.loading')} isCentered />
  );
};

export const Error = ({ message }) => {
  return <EmptyFeed message={message} />;
};

Error.defaultProps = {
  message: 'There was an error loading the photos.',
};

export const NoContent = ({ children, type }) => {
  return (
    <EmptyFeed
      message={`This ${type.toLowerCase()} doesn't have any photos yet.`}
      data-testid="photos__empty-state-add-photo"
    >
      {children}
    </EmptyFeed>
  );
};

NoContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  type: PropTypes.string,
};

Error.propTypes = {
  message: PropTypes.string,
};

EmptyFeed.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isLoading: PropTypes.bool,
  message: PropTypes.string,
};

EmptyFeed.defaultProps = {
  isLoading: false,
  message: '',
};

export default EmptyFeed;
